'use client';

import { createContext, useContext } from 'react';
import { ClientBrandConfig } from 'types/brand-config';

type ClientBrandT = {
  brand: ClientBrandConfig;
};

const ClientBrand = createContext<ClientBrandT>({
  brand: {} as any // stub, replaced by a hostname brand lookup
});

const ClientBrandProvider: React.FC<{
  children: React.ReactNode;
  brand: ClientBrandConfig;
}> = ({ children, brand }) => {
  return (
    <ClientBrand.Provider value={{ brand }}>{children}</ClientBrand.Provider>
  );
};

export const useClientBrand = () => {
  const context = useContext(ClientBrand);
  if (!context || !context.brand) {
    throw new Error('Hook must be called within ClientBrandProvider.');
  }
  return context;
};

export default ClientBrandProvider;
